import React from 'react';
import NftImage from '../../../../../../general/nft/image';
import LoadableImage from '../../../../../../general/loadableImage';
import { API_NftDetails } from 'shared';

interface Props {
  nft: API_NftDetails | undefined;
  showPh: boolean;
  className: string;
  loading?: boolean;
}

const LandingMintSectionNftImage = ({
  nft,
  loading,
  showPh,
  className
}: Props) => {
  if (nft && !showPh) {
    return <NftImage nft={nft} loading={loading} className={className} />;
  }
  return (
    <LoadableImage
      src='/assets/images/landing/mint_page/hand_loading.png'
      className={className}
    />
  );
};

export default LandingMintSectionNftImage;
